import React from "react";
import { ToastDescriptionProps } from "./Toast.types";
import { Description as StyledDescription } from "./Description.styles";

/**
 * Typography.BodyText styled to fit on the Toast layout
 */
export const Description = ({ children, className }: ToastDescriptionProps) => (
  <StyledDescription className={className}>{children}</StyledDescription>
);
